import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=bdbd5fc4&"
import script from "./SectionItem.vue?vue&type=script&lang=js&"
export * from "./SectionItem.vue?vue&type=script&lang=js&"
import style0 from "./SectionItem.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../Valuation/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports